import { testimonials } from "@/mocks/testimonials";

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="mb-12">
          <span className="inline-block px-4 py-1.5 text-xs font-medium text-accent-600 bg-accent-50 rounded-full mb-4 whitespace-nowrap">
            Avaliações Reais
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-2">
            O Que Nossos Usuários Dizem
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            Sobre a CSSBuySpreadsheet
          </p>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-5 space-y-5">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-background-100 rounded-xl p-5 break-inside-avoid"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-semibold text-accent-600">
                    {t.avatar}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">
                    {t.name}
                  </p>
                  <p className="text-xs text-foreground-500">{t.username}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                &ldquo;{t.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}